const UXCAM_ACCOUNT_ID = import.meta.env.VITE_UXCAM_ACCOUNT_ID;
const CLARITY_PROJECT_ID = import.meta.env.VITE_CLARITY_PROJECT_ID;

export const getUXCamUserSessionURL = (userId: string) =>
  `https://app.uxcam.com/app/${UXCAM_ACCOUNT_ID}/sessions/list/1?user_custom_property=%7B%22o%22:%22in%22,%22pn%22:%22userId%22,%22pv%22:%5B%22${userId}%22%5D,%22tb%22:%22appuser%22%7D`;

export const getClarityUserSessionURL = (userId: string) =>
  `https://clarity.microsoft.com/projects/view/${CLARITY_PROJECT_ID}/impressions?CustomUserId=is%3B${userId}`;
